import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';

const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('delta2portablepowerstation.delta2');

    return (
        <div className={`${css.gotoPage} goto-page GtmModuleData-section`} data-section-id={css.gotoPage} data-section-title={t('power_security_title')}>
            <div className="page-panel">
                <EFPic name={['goto-page1.webp', 'goto-page1.png']} />
                <div className="text-wrapper">
                    <p className="title">{t('power_security_title')}</p>
                    <p className="desc">{t('power_security_desc')}</p>
                    <Link
                        className="learn-more"
                        href="https://au.ecoflow.com/pages/disaster"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_product',
                            product_name: t('power_security_title'),
                            list_name: t('power_security_title'),
                            button_name: t('learn_more'),
                        }}
                    >
                        {t('learn_more')} <EFArrowLeft color="#2673ff" width="12px" height="18px" />
                    </Link>
                </div>
            </div>

            <div className="page-panel">
                <EFPic name={['goto-page2.webp', 'goto-page2.png']} />
                <div className="text-wrapper">
                    <p className="title">{t('whole_home_title')}</p>
                    <p className="desc">{t('whole_home_desc')}</p>
                    <Link
                        className="learn-more"
                        href="/whole-home-backup-power-solution"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_product',
                            product_name: t('whole_home_title'),
                            list_name: t('whole_home_title'),
                            button_name: t('learn_more'),
                        }}
                    >
                        {t('learn_more')} <EFArrowLeft color="#2673ff" width="12px" height="18px" />
                    </Link>
                </div>
            </div>
        </div>
    );
}
